module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Location":"Standort","Name":"Name","Description":"Beschreibung","Category":"Kategorie","Meta Tags":"Meta-Tags","Homepage URL":"Webseite","Phone":"Telefon","Email":"E-Mail","Business Image":"Geschäftsbild","Select from library":"Aus Mediathek wählen","Opening Hours":"Öffnungszeiten","Can visit location":"Besuchbar vor Ort","Delivery service":"Lieferservice"}}')
  delete Component.options._Ctor
}
